// Ophalen van de maandredactie.
//
// EIGEN FETCH-WRAPPER, BEWUST EN TIJDELIJK. `lib/api.ts` is de enige plek waar
// dit dashboard het netwerk aanraakt, en dat hoort zo te blijven — maar dat
// bestand wordt op dit moment door de chat-schermkant-sessie bewerkt, en één
// gedeeld bestand met twee schrijvers is precies waar W15 en W16 op stukliepen.
// Dus lenen we `ApiError` (dat is de foutafhandeling die het scherm toont) en
// doen we de aanroep zelf. Samenvoegen zodra die sessie klaar is; het is één
// functie verplaatsen.

import type { RedactieEdities, RedactieEditie } from "../contracts";
import { ApiError, wieKoppen } from "./api";
import { useResource, type Resource } from "./useResource";

async function haal<T>(pad: string): Promise<T> {
  let res: globalThis.Response;
  try {
    res = await fetch(`/api${pad}`, { headers: { Accept: "application/json", ...(await wieKoppen()) } });
  } catch (err) {
    throw new ApiError(0, pad, err instanceof Error ? err.message : "netwerkfout");
  }
  if (!res.ok) {
    let detail = `${res.status} ${res.statusText}`;
    try {
      const body = (await res.json()) as { detail?: unknown };
      if (typeof body.detail === "string") detail = body.detail;
    } catch {
      // geen json-body; de statusregel is dan het beste wat we hebben
    }
    throw new ApiError(res.status, pad, detail);
  }
  return (await res.json()) as T;
}

/**
 * Alle beschikbare edities. BEWUST ZONDER VERPLICHTE FILTERS: zonder inlog
 * weet het scherm niet bij welke propositie de bezoeker hoort, en dan is
 * "welke edities bestaan er eigenlijk" de enige eerlijke vraag. De workspace
 * kiest daarna zelf welke hij toont en zegt erbij dat het een voorbeeld is.
 */
export function useEdities(
  propositie?: string | null,
  rol?: string | null,
): Resource<RedactieEdities> {
  const query = [
    propositie ? `propositie=${encodeURIComponent(propositie)}` : "",
    rol ? `rol=${encodeURIComponent(rol)}` : "",
  ]
    .filter(Boolean)
    .join("&");
  return useResource<RedactieEdities>(
    () => haal<RedactieEdities>(`/redactie/edities${query ? `?${query}` : ""}`),
    [propositie, rol],
  );
}

export function useEditie(
  propositie: string | null,
  rol: string | null,
  maand: string | null,
): Resource<RedactieEditie> {
  return useResource<RedactieEditie>(
    () =>
      haal<RedactieEditie>(
        `/redactie/editie?propositie=${encodeURIComponent(propositie ?? "")}` +
          `&rol=${encodeURIComponent(rol ?? "")}` +
          (maand ? `&maand=${encodeURIComponent(maand)}` : ""),
      ),
    [propositie, rol, maand],
    Boolean(propositie && rol),
  );
}
